import React from 'react'
import { CGE } from '../../../../common/components/CGE'
import { urlParams, getPageLayoutType, decode_utf8, getSignedIdStatus, validateEmailFunc, validateCell, transformId } from '../../../../common/utils/utilsFunc'
import SubscriptionsContextProvider, { ACTIONS, SubscriptionsContext } from '../../context/SubscriptionsContextProvider';
import AlertModal from "../../../../common/components/AlertModal";
import { useModal } from "@clayui/modal";
import "../../styles/index.scss"
import Loading from "../../../../common/components/Loading";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';

function AltaSubscriptions({ props }) {
    const [state, dispatch] = React.useContext(SubscriptionsContext)
    const [valueProprietary, setValueProprietary] = React.useState(true)
    const [valueLeaseholder, setValueLeaseholder] = React.useState(false)
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [idClientPriv, setIdClientPriv] = React.useState('')
    const [detailClientJsonPriv, setDetailClientJsonPriv] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    const [errorMsg, setErrorMsg] = React.useState(false);
    const [visibleModal, setVisibleModal] = React.useState(false);

    const [visibleModalReturn, setVisibleModalReturn] = React.useState(false);
    const [msgModalReturn, setMsgModalReturn] = React.useState(false);
    const [errorCli, setErrorCli] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
            setVisibleModalReturn(false);

        },
    });
    const [values, setValues] = React.useState({
        idClient: '',
        nameClient: '',
        email: '',
        emailConfirm: '',
        cellphone: ''
    })
    const [inputValidate, setInputValidate] = React.useState({
        empty: {},
        validated: {},
        msg: {}
    });

    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);


    let propsLabelInfoContent = {
        "setVisibleModal": setVisibleModal,
        "observer": observer,
        "onClose": onClose,
        "visibleModal": visibleModal,
        "titleModal": "Información",
        "status": "info",
        "content": state?.webContentTextInfo,
        "titleHint": "Ayuda Nro de Cliente",
    }

    React.useEffect(() => {
        let canal = urlParams.get('canal')
        let ctacto = urlParams.get('ctacto')
        if (canal) {
            setValues({ ...values, canal: canal, idClient: ctacto })
        } else if (getPageLayoutType()) {
            setValues({ ...values, canal: "OV", idClient: ctacto })
        } else if (!getPageLayoutType()) {
            setValues({ ...values, canal: "URL", idClient: ctacto })
        } else {
            setValues({ ...values, canal: "", idClient: ctacto })
        }
        if(getPageLayoutType()){
            handleClickButtonClient(ctacto);
        }
    }, [])

    function setInitialStateForms() {
        setValues({
            idClient: getPageLayoutType() ? values.idClient : '',
            nameClient: '',
            email: '',
            emailConfirm: '',
            cellphone: '',
            canal: values.canal
        })

        setInputValidate({
            empty: {},
            error: {},
            msg: {}
        });
    }

    function handleClickButtonClient(id) {
        if (id) {
            setErrorCli(false);
            setIdClientPriv(id)
        } else if(!getPageLayoutType() && values.idClient){
            setErrorCli(false);
            props.setIdClient(values.idClient)
        } else {
            setErrorCli(true);
        }
    }

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    function funcClickBack() {
        window.location.href = getPageLayoutType() ? `/group/guest/suscripciones` : '/servicios-en-linea'
    }

    function funcValidate() {
        let errors = {
            empty: {},
            validated: {},
            msg: {}
        };

        if (values.idClient) {
            errors.empty.idClient = false;
        } else {
            errors.empty.idClient = true;
            errors.msg.idClient = "Debe ingresar un Nro de Cliente"
        }

        if (values.nameClient) {
            errors.empty.nameClient = false;

        } else {
            errors.empty.nameClient = true;
            errors.msg.nameClient = "Debe ingresar el Nombre y Apellidos"
        }

        if (values.email) {
            errors.empty.email = false;
            if (values.email && !validateEmailFunc(values.email)) {
                errors.validated.email = true;
                errors.msg.email = "Debe ingresar el Correo Electrónico válido"
            } else {
                errors.validated.email = false;
            }
        } else {
            errors.empty.email = true;
            errors.msg.email = "Debe ingresar el Correo Electrónico"
        }

        if (values.emailConfirm) {
            errors.empty.emailConfirm = false;
            if (values.emailConfirm && !validateEmailFunc(values.emailConfirm)) {
                errors.validated.emailConfirm = true;
                errors.msg.emailConfirm = "Debe ingresar el Correo Electrónico válido  para confirmar"
            } else if (values.emailConfirm !== values.email) {
                errors.validated.emailConfirm = true;
                errors.msg.emailConfirm = "Los Correos Electrónicos no coinciden"
            } else {
                errors.validated.emailConfirm = false;
            }
        } else {
            errors.empty.emailConfirm = true;
            errors.msg.emailConfirm = "Debe confirmar el Correo Electrónico"
        }

        if (validateCell(values.cellphone)) {
            errors.validated.cellphone = true;
            errors.msg.cellphone = "Debes ingresar un teléfono válido"
        } else {
            errors.validated.cellphone = false;
        }

        setInputValidate(errors)
        return errors
    }

    function funcClick() {
        const objErros = funcValidate();
        if (Object.values(objErros?.msg).length > 0) {
            setError(true)
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        } else if (!verifReCaptcha && !getPageLayoutType()) {
            setError(true)
            setErrorMsg("Falta validar que no eres un Robot.")
        }
        else {
            setError(false)
            let json = {
                "email": values.email,
                "correoContentName": decode_utf8(props.correo_content_name_confirmacion_alta_subscription),
                "nroCliente": values.idClient,
                "empresa": props.codigo_empresa,
                "url": props.url_ws_empresa,
                "canal": values.canal,
                "phone": values.cellphone,
                "nombre": values.nameClient,
                "signedIn": getSignedIdStatus(),
                // eslint-disable-next-line no-undef
                "siteId": `${Liferay.ThemeDisplay.getScopeGroupId()}`,  
                "paginaConfirmacion": props.pagination_confirmation_alta_subscription,
                "claveParam": props.claveParam? props.claveParam : ''
            }
            if (!getSignedIdStatus()){
                json.owner = valueProprietary ? true : false
            }
            setLoading(true)
            dispatch({
                payload: json,
                type: ACTIONS.SET_JSON_ALTA_SUBSCRIPTION

            })
        }

    }

    React.useEffect(() => {
        if(state.detailClient && idClientPriv){
          setLoading(false)
          if(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN || state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
            if(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0){
              setDetailClientJsonPriv(state.detailClient?.ConsultarDetalleCtaCtoResponse?.ITEM)
            } else {
                setDetailClientJsonPriv([])
                props.setGlobalAlert(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN ? state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN : decode_utf8(props.text_fetch_error) ,"warning", true, "Advertencia");
            }
          } else {
            setDetailClientJsonPriv([])
            props.setGlobalAlert(decode_utf8(props.text_fetch_error),"warning", true, "Advertencia");
          }
        }
    }, [state.detailClient])

    React.useEffect(() => {
        if (state.responseAltaSubscription) {
            setLoading(false)
            if (state.responseAltaSubscription?.code || state.responseAltaSubscription?.code === 0) {
                if (state.responseAltaSubscription?.code === 0) {
                    setVisibleModalReturn(true)
                    setMsgModalReturn(state.responseAltaSubscription?.message)
                    setInitialStateForms();
                } else {
                    props.setGlobalAlert(state.responseAltaSubscription?.message ? state.responseAltaSubscription?.message : props.text_fetch_error, "warning", true, "Advertencia");
                }

            } else {
                props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
            }
            
        }

    }, [state.responseAltaSubscription])

    function funcClickChangeName() {
        window.open(`/group/guest/cambio-de-nombre`, "_blank") 
    }

    React.useEffect(() => {
        if (error) {
            props.setGlobalAlert(errorMsg, "warning", true, "Advertencia");
        }
    }, [error])

    React.useEffect(() => {
        if (idClientPriv) {
            setLoading(true)
            dispatch({
                type: ACTIONS.SET_IDCLIENT,
                payload: idClientPriv
            })
        }
    }, [idClientPriv])

    return (
        <CGE.Panel title={decode_utf8(props.title_alta_subscription)} description={decode_utf8(props.description_alta_subscription)}>
            <div className="row">
                <div className={getPageLayoutType() ? "col-md-12 px-0" : "col-md-12"}>
                    <CGE.DetailClient
                        props={{
                            handleChange: (e) => {
                                setValues({ ...values, idClient: e.target.value });
                                props.setDetailClientJson([]);
                                setDetailClientJsonPriv([]);
                            },
                            handleChangePriv: (e) => setValues({ ...values, idClient: e.target.value }),
                            handleClick: () => { handleClickButtonClient(urlParams.get('ctacto')) },
                            hasError: errorCli || inputValidate?.empty?.idClient,
                            msgError: "Debe ingresar un Nro de Cliente",
                            idClient: values.idClient,
                            idFormElement: "idClient",
                            labelButton: "Buscar",
                            labelName: "N° de Cliente",
                            mandatoryElement: true,
                            propsLabelInfoContent: propsLabelInfoContent,
                            readOnly: urlParams.get('ctacto') ? true : false,
                            sizeButton: "sm",
                            typeButton: "primary",
                            typeFormElement: "text",
                            typeElement:"input-mask",
                            maxLength:"12",
                            formatChars:{
                                9: "[0-9]"
                            },
                            mask:"999999999999",
                            valuePriv: values.idClient,
                            valuePub: values.idClient
                           
                        }}
                        propsDetail= { detailClientJsonPriv?.CTA_CTO ? {
                            fullNameClient: (detailClientJsonPriv?.PRIMER_NOMBRE_PERSONA || detailClientJsonPriv?.SEGUNDO_NOMBRE_PERSONA
                                || detailClientJsonPriv?.APELLIDO_PERSONA) ? `${detailClientJsonPriv?.PRIMER_NOMBRE_PERSONA} ${detailClientJsonPriv?.SEGUNDO_NOMBRE_PERSONA} ${detailClientJsonPriv?.APELLIDO_PERSONA}` : "",
                            comunaClient: detailClientJsonPriv?.COMUNA ? detailClientJsonPriv?.COMUNA : "",
                            calleClient: detailClientJsonPriv?.CALLE ? detailClientJsonPriv?.CALLE : "",
                            nCalleClient: detailClientJsonPriv?.NUMERO_CASA ? detailClientJsonPriv?.NUMERO_CASA : "",
                            dptoBlockClient: (detailClientJsonPriv?.SUPLEMENTO || detailClientJsonPriv?.PISO) ? `${detailClientJsonPriv?.SUPLEMENTO} 
                        ${detailClientJsonPriv?.PISO}` : "",
                            ctaCtoClient: detailClientJsonPriv?.CTA_CTO
                        }: {
                            fullNameClient: "",
                            comunaClient: props.detailClientJson?.COMUNA ? props.detailClientJson?.COMUNA : "",
                            calleClient: props.detailClientJson?.CALLE ? props.detailClientJson?.CALLE : "",
                            nCalleClient: props.detailClientJson?.NUMERO_CASA ? props.detailClientJson?.NUMERO_CASA : "",
                            dptoBlockClient: (props.detailClientJson?.SUPLEMENTO || props.detailClientJson?.PISO) ? `${props.detailClientJson?.SUPLEMENTO} 
                        ${props.detailClientJson?.PISO}` : "",
                            ctaCtoClient: props.detailClientJson?.CTA_CTO
                        }}
                    />
                </div>

                <div class="col-md-6">
                    <CGE.FormsField
                        labelName="Nombre / Apellidos"
                        idFormElement="nameClient"
                        handleChange={(e) => setValues({ ...values, nameClient: e.target.value })}
                        typeFormElement="text"
                        typeElement="input"
                        value={values.nameClient}
                        mandatoryElement={true}
                        hasError={inputValidate?.empty?.nameClient || inputValidate?.validated?.nameClient}
                        msgError={inputValidate?.msg?.nameClient}
                    />
                </div>

                <div class="col-md-6">
                    <CGE.FormsField
                        labelName="Celular"
                        idFormElement="cellphone"
                        handleChange={(e) => setValues({ ...values, cellphone: e.target.value })}
                        typeFormElement="text"
                        typeElement="input"
                        value={values.cellphone}
                        maxLength="9"
                        minLength="9"
                        hasError={inputValidate?.empty?.cellphone || inputValidate?.validated?.cellphone}
                        msgError={inputValidate?.msg?.cellphone}
                        placeholder="Ej: 912345678"
                    />
                </div>

                <div class="col-md-6">
                    <CGE.FormsField
                        labelName="Correo electrónico"
                        idFormElement="email"
                        handleChange={(e) => setValues({ ...values, email: e.target.value })}
                        typeFormElement="text"
                        typeElement="input"
                        value={values.email}
                        mandatoryElement={true}
                        hasError={inputValidate?.empty?.email || inputValidate?.validated?.email}
                        msgError={inputValidate?.msg?.email}

                    />
                </div>
                <div class="col-md-6 mb-1">
                    <CGE.FormsField
                        labelName="Confirmar correo electrónico "
                        idFormElement="emailConfirm"
                        handleChange={(e) => setValues({ ...values, emailConfirm: e.target.value })}
                        typeFormElement="text"
                        typeElement="input"
                        value={values.emailConfirm}
                        mandatoryElement={true}
                        hasError={inputValidate?.empty?.emailConfirm || inputValidate?.validated?.emailConfirm}
                        msgError={inputValidate?.msg?.emailConfirm}

                    />
                </div>

                {!getPageLayoutType() &&
                   <div class="col-md-6">
                   <CGE.CheckBoxGroup
                       optionsGroup={[{
                           "checked": valueProprietary,
                           "horizontal": true,
                           "labelName": "Propietario",
                           "handleChange": () => {
                               setValueProprietary((val) => !val)
                               setValueLeaseholder((val) => !val)

                           },
                           "idFormElement": "checkbox1",
                           "typeFormElement": "checkbox",
                           "mandatoryElement": false,
                           "typeElement": "input"
                       },
                       {
                           "checked": valueLeaseholder,
                           "horizontal": true,
                           "labelName": "Arrendatario",
                           "handleChange": () => {
                               setValueProprietary((val) => !val)
                               setValueLeaseholder((val) => !val)
                           },
                           "idFormElement": "checkbox2",
                           "typeFormElement": "checkbox",
                           "mandatoryElement": false,
                           "typeElement": "input"
                       }]}
                       labelNameCheckBoxGroup="Tipo de persona"
                       mandatoryElement={true}
                       horizontal={true}
                   />
               </div>
                }
                


                {!getPageLayoutType() &&
                    <div className="col-md-12">
                        <CGE.FieldRecaptcha
                            onChange={onChangeReCaptcha}
                            sitekey={props.api_key_recaptcha}
                        />
                    </div>
                }
                <div class="col-md-12">
                    <CGE.RenderContent textContent={state?.webContentAltaSubscriptionTextInfo} />
                </div>
                <div class="col-md-12">
                    <div className="d-flex justify-content-between">
                        <CGE.Button
                            className="mr-3"
                            label="Volver"
                            onClick={() => funcClickBack()}
                            type="secondary"
                        />
                        <CGE.Button
                            label="Aceptar"
                            disabled={detailClientJsonPriv.length === 0 && getPageLayoutType()?true:false}
                            onClick={() => funcClick()}
                        />
                    </div>
                    <CGE.Spacing type="md" />
                </div>
                {!getPageLayoutType() &&
                    <div class="col-md-12 cge_subscription_change_name">
                        <CGE.RenderContent textContent={state?.webContentNoteSubscriptionPub} />
                    </div>}
            </div>
            {visibleModalReturn && (
                <AlertModal
                    titleModal="Confirmación"
                    msgModal={msgModalReturn}
                    observer={observer}
                    onClose={onClose}
                    status="success"
                />
            )}
            {loading && <Loading />}
        </CGE.Panel>
    )
}

const AltaSubscriptionsWithProvider = ({
    props

}) => (
    <SubscriptionsContextProvider>
        <AltaSubscriptions
            props={props}
        />
    </SubscriptionsContextProvider>
);

export default AltaSubscriptionsWithProvider;